import $ from 'jquery'

$(document).ready(function () {
  // Categories
  if ($('body').hasClass('page-template-template-downloads')) {
    hideFilters()
    $('ul.categories').on('click', 'li.filter', function () {
      hideFilters()
      const value = $(this).hasClass('selected')
        ? ''
        : $(this).attr('data-value')
      composeUrl('category', value)
    })
  }

  // Collections
  $('select.collections').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('col', value)
  })

  // Typologies
  $('select.typologies').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('typology', value)
  })

  // Free Search
  $('#find_btn').on('click', function () {
    const value = $('#find').val()
    if (value !== '') {
      composeUrl('find', value)
    }
  })

  // Reset Free Search
  $('#empty_search').on('click', function () {
    $('#find').val('')
    composeUrl('find', '')
  })

  // Pagination
  $('span.page-number').on('click', function () {
    const value = $(this).attr('data-value')
    composeUrl('pg', value)
  })
})

function composeUrl (key, value) {
  const url = new URL(document.location.href)

  // Check for category (has default)
  if (key == 'category') {
    if (value === '') {
      value = $('#category_default').val()
    }
  }

  // Remove element if is already present and values is empty
  if (url.searchParams.has(key) && value === '' && key != 'category') {
    url.searchParams.delete(key)
  } else {
    url.searchParams.set(key, value)
  }

  // Check for configurable param
  if (key === 'configurable' && value === false) {
    url.searchParams.delete(key)
  }

  // Check pagination offsets
  if (url.searchParams.has('pg')) {
    const max = $('input[name="max-pages"]').val() ?? 1
    if (parseInt(url.searchParams.get('pg')) > parseInt(max)) {
      url.searchParams.delete('pg')
    }
  }

  // Remove pagination if another filter is entered
  if (key !== 'pg' && url.searchParams.has('pg')) {
    url.searchParams.delete('pg')
  }

  // fix: now remove other filters if categories is not the default one
  const defaultCategory = $('#category_default').val()
  if (key === 'category' && value !== defaultCategory) {
    // remove collections if present
    if (url.searchParams.has('col')) {
      url.searchParams.delete('col')
    }
    // remove typologies if present
    if (url.searchParams.has('typology')) {
      url.searchParams.delete('typology')
    }
  }

  // Redirect
  document.location = url.href
}

function hideFilters () {
  const selectedCategory = $('ul.categories li.selected').attr('data-value')
  const defaultCategory = $('#category_default').val()

  if (selectedCategory !== defaultCategory) {
    $('div.download-archive__secondary-filters div.filter-selections').hide()
  } else {
    $('div.download-archive__secondary-filters div.filter-selections').show()
  }
}
